import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, Heart } from 'lucide-react';

const DonateSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cream-100 flex items-center justify-center py-12 px-4" data-testid="donate-success-page">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Heart className="w-10 h-10 text-green-600" />
          </div>
          <h2 className="font-heading text-2xl font-bold text-gray-900 mb-2">
            Thank You for Your Seva!
          </h2>
          <p className="text-gray-600 mb-2">
            ਵਾਹਿਗੁਰੂ ਜੀ ਕਾ ਖਾਲਸਾ, ਵਾਹਿਗੁਰੂ ਜੀ ਕੀ ਫਤਿਹ
          </p>
          <p className="text-gray-600 mb-6">
            Your generous donation helps us serve the global Sikh community. May Waheguru bless you!
          </p>
          <div className="space-y-3">
            <Button onClick={() => navigate('/')} className="w-full btn-primary">
              Return Home
            </Button>
            <Button onClick={() => navigate('/donate')} variant="outline" className="w-full btn-outline">
              Donate Again
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DonateSuccessPage;
